// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Dialog, DialogContent } from '@mui/material';
import { AddCash } from './add-cash';
import { type BasePortfolio } from '@shared/data-access/interfaces/common/base-portfolio';
import type { Paths } from '@shared/data-access/interfaces/routes/paths';

interface AddCashModalProps {
  dataPortfolio: BasePortfolio;
  openModal: boolean;
  handleClose: () => void;
  to: Paths;
  portfolioName?: string;
}

export const AddCashModal = ({
  dataPortfolio,
  openModal,
  handleClose,
  portfolioName,
  to,
}: AddCashModalProps) => {
  return (
    <Dialog
      open={openModal}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;

        handleClose();
      }}
      classes={{ paper: '!w-[520px] !max-w-[calc(100%-2rem)]' }}
    >
      <DialogContent classes={{ root: '!p-10' }}>
        <AddCash
          dataPortfolio={dataPortfolio}
          portfolioName={portfolioName}
          to={to}
          onCancel={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};
